export type MerryLeftNavigationItemId =
  | "newChat"
  | "chatHistory"
  | "home"
  | "dataOverview"
  | "myFiles"
  | "notifications";

export type MerryLeftNavigationRouteItemId = Exclude<
  MerryLeftNavigationItemId,
  "newChat"
>;

export interface MerryLeftNavigationItemDefinition {
  figmaNodeId: string;
  id: MerryLeftNavigationItemId;
  kind: "action" | "route";
  label: string;
}

export const merryLeftNavigationSections = [
  [
    {
      figmaNodeId: "300:32333",
      id: "newChat",
      kind: "action",
      label: "新建对话",
    },
    {
      figmaNodeId: "300:32337",
      id: "chatHistory",
      kind: "route",
      label: "历史记录",
    },
  ],
  [
    {
      figmaNodeId: "300:32344",
      id: "home",
      kind: "route",
      label: "首页",
    },
    {
      figmaNodeId: "300:32348",
      id: "dataOverview",
      kind: "route",
      label: "数据概览",
    },
  ],
  [
    {
      figmaNodeId: "300:32352",
      id: "myFiles",
      kind: "route",
      label: "我的文件",
    },
    {
      figmaNodeId: "300:32356",
      id: "notifications",
      kind: "route",
      label: "通知",
    },
  ],
] as const satisfies ReadonlyArray<
  ReadonlyArray<MerryLeftNavigationItemDefinition>
>;

export const merryLeftNavigationDividerNodeIds = [
  "300:32341",
  "339:68687",
] as const;

export function isMerryLeftNavigationRouteItem(
  item: MerryLeftNavigationItemDefinition,
): item is MerryLeftNavigationItemDefinition & {
  id: MerryLeftNavigationRouteItemId;
  kind: "route";
} {
  return item.kind === "route";
}
